import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router} from '@angular/router';
import {AuthenticationService} from './authentication.service';
import {ROUTES} from '../../app.routes';

@Injectable()
export class RoleGuardService implements CanActivate
{
    constructor(public authenticationService: AuthenticationService, public router: Router)
    {
    }

    /**
     * Check if the user logged-in has the correct permission to access the current route. The user
     * will be redirected to the home page if not. This component does not validate the actual user
     * login, that is assumed to be validated by another auth-guard service.
     */
    canActivate(route: ActivatedRouteSnapshot): boolean
    {
        if (route.data == null || !this.authenticationService.hasRouteAccess(route.data.permissions))
        {
            this.router.navigate([ROUTES.SECURE.HOME.VIEW.path]).then();
            return false;
        }
        return true;
    }
}